export default {
    notify: {
        title: 'Notifications',
        approvalPerson: {
            one: 'You have new person for approving',
            other: 'You have %(count)s new persons for approving'
        },
        approvalProject: {
            one: 'You have new vacancy for approving',
            other: 'You have %(count)s new vacancies for approving'
        },
        notDone: {
            one: 'You have new event in not done list',
            other: 'You have %(count)s new event in not done list',
        },
        emptyList: 'You have no notifications',
        pushTitle: {
            person: 'Approval peoples',
            notdone: 'Events for today',
            project: 'Approval vacancies',
        },
        toolTip: {
            notDone: 'Event scheduled: %(notDoneCount)s',
            events: 'Notification one hour before the event',
        },
        errors: {
            permission: 'Enable notifications in your browser settings.',
        }
    },
    notificationPermission: 'Device permission',
    notificationUnsupported: 'Unsupported on your device/browser',
    subscriptionStatus: 'Subscription status',
    subscriptionEnable: 'Enable',
    subscriptions: 'Subscriptions:',
    options: {
        notifyProjectsEnabled: 'Vacancies approvals',
        notifyPersonEnabled: 'People approvals',
        notifyNotDoneEnabled: 'Events for today',
        notifyEventEnabled: 'Events',
        notifyChangeRequestStatusEnabled: 'Requests',
    },
}
